import { hdcpExtension } from '@cbsinteractive/avia-js-hdcp';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AviaExtension } from 'tag/ts/tag/player/adapters/avia/extensions/AviaExtension';
import { IAviaExtension } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaExtension';

export class HdcpCapabilitiesExtension extends AviaExtension implements IAviaExtension {
	package = hdcpExtension;
	namespaceKey = 'plugin_hdcp';

	constructor( argument: ITagAbstractClassArgument ) {
		super( {
			...argument,
			name: 'HdcpCapabilitiesExtension'
		} );
	}

	shouldBeUsed() {
		if ( !super.shouldBeUsed() ) return false;

		this?.logger?.log( 'Checking if device', this.tag.params?.SYSTEM?.device, ' requires HDCP' );
		const isHDCPDevice = [
			EmbedDevice.XBOX_ONE,
			EmbedDevice.PS4,
			EmbedDevice.PS5,
			EmbedDevice.COMCAST,
			EmbedDevice.COX,
			EmbedDevice.VIDAA,
			EmbedDevice.DESKTOP
		].includes( this.tag.params?.SYSTEM?.device );
		if ( isHDCPDevice ) {
			this?.logger?.log( 'HDCP device detected:', this.tag.params?.SYSTEM?.device );
		}

		return isHDCPDevice;
	}
}